import { AccountsEntity } from '@/domain/entities/account';
import { UpdateRequiredMfaPayload } from '@/domain/ports/account/payloads';
import { AccountsRepository } from '@/domain/ports/account/repositories';

export class UpdateRequiredMfaUseCase {
  constructor(private readonly repository: AccountsRepository) {}

  async run(payload: UpdateRequiredMfaPayload): Promise<AccountsEntity> {
    const account = await this.repository.updateRequiredMfa(payload);

    return account;
  }
}
